import { Environments } from '@innovyze/stylovyze';

import config from './config.api';
import { formatUrlTrailing } from '@Utils/urlFormatting';
import { axiosWithHeaders, getService } from '@innovyze/lib_get_service';

const apiEnv =
	(localStorage.getItem('apiEnv') as keyof typeof Environments) || undefined;

export const riskBaseUrl = formatUrlTrailing(
	getService('amRisk', config, apiEnv),
);

const riskService = axiosWithHeaders({
	service: 'amRisk',
	config,
	axiosCreateOpts: {
		timeout: 30000,
	},
});

export default riskService;
